import JwtService from '@/common/jwt.service'

export default {
  user: {},
  employee: {},
  userRole: null,
  token: JwtService.getToken(),
  isAuthenticated: !!JwtService.getToken()
}
